import { useCallback, useEffect, useState, createRef } from 'react'
import { useEffectOnce } from 'usehooks-ts'
import styled from 'styled-components'

const GridItem = ({
  tenant,
  colorMode,
  title,
  titleMobile,
  image,
  caption,
  name,
  party,
  text,
  className,
}: {
  tenant?: object
  colorMode?: string
  title: string
  titleMobile: string
  image?: string
  caption?: string
  name: string
  party: string
  text: string
  className?: string
}) => {
  const [isMobile, setIsMobile] = useState(false)
  const [isSmallMobile, setIsSmallMobile] = useState(false)

  const handleResize = (): void => {
    setIsMobile(window.innerWidth < 1024)
    setIsSmallMobile(window.innerWidth < 600)
  }

  useEffectOnce(() => {
    // set height when window is resized
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  })

  return (
    <Griditem>
      {className === 'odd' && (
        <div className={'top ' + className + ' ' + party.toLowerCase()}>
          <div className='left'>
            <div className='photo'>
              <img src={require(`./images/${image}.jpg`)} alt={name} />
              <div className='party'>
                <span>{party}</span>
              </div>
              <div className='caption'>{caption}</div>
            </div>
          </div>

          <div className='right'>
            <h3
              dangerouslySetInnerHTML={{
                __html: isSmallMobile ? titleMobile : title,
              }}
            />
            <div className='info'>
              <h4 dangerouslySetInnerHTML={{ __html: name }} />
            </div>
          </div>
        </div>
      )}

      {className === 'even' && (
        <div className={'top ' + className + ' ' + party.toLowerCase()}>
          <div className='left'>
            <h3
              dangerouslySetInnerHTML={{
                __html: isSmallMobile ? titleMobile : title,
              }}
            />
            <div className='info'>
              <h4 dangerouslySetInnerHTML={{ __html: name }} />
            </div>
          </div>

          <div className='right'>
            <div className='photo'>
              <img src={require(`./images/${image}.jpg`)} alt={name} />
              <div className='party'>
                <span>{party}</span>
              </div>
              <div className='caption'>{caption}</div>
            </div>
          </div>
        </div>
      )}

      <div className='text' dangerouslySetInnerHTML={{ __html: text }} />
    </Griditem>
  )
}
const Griditem = styled.div`
  color: var(--text-color);
  border-bottom: 1px solid #d4d4d4;
  padding-bottom: 1.8rem;
  margin-bottom: 3.4rem;

  h3 {
    margin-top: 2.2rem;
    font-size: 2.5rem;
    line-height: 3.6rem;
    font-family: var(--font-serif);
    @media only screen and (max-width: 600px) {
      font-size: 2.1rem;
      line-height: 2.8rem;
    }
    font-weight: 400;
  }
  .info {
    bottom: 6rem;
    position: absolute;
    h4 {
      font-family: var(--font-sans-serif);
      font-size: 2.4rem;
      @media only screen and (max-width: 600px) {
        font-size: 2.1rem;
      }
      line-height: 2.8rem;
      font-weight: 600;
      margin-bottom: 0.3rem;
      @media only screen and (max-width: 600px) {
        margin-bottom: 0.1rem;
      }
    }
    .party {
      font-size: 1.7rem;
      @media only screen and (max-width: 600px) {
        font-size: 1.5rem;
      }
    }
  }
  .photo {
    position: relative;
    margin-bottom: 1.4rem;
    img {
      width: 100%;
      margin-bottom: 0;
      border-bottom: 8px solid grey;
    }
  }
  .caption {
    color: var(--gray-3);
    font-size: 1.2rem;
    line-height: 2rem;
    margin-top: 0;
    margin-bottom: 0;
    top: -0.6rem;
    position: relative;
  }
  .text {
    font-size: 1.75rem;
    text-align: left;
    font-family: var(--font-serif);
    a:hover,
    a:link,
    a:active,
    a:visited {
      background-image: linear-gradient(90deg, #ffe462, #ffe462);
      background-repeat: repeat-x;
      background-position: bottom;
      background-size: 100% 20%;
      transition: all 0.1s ease-in-out;
      color: var(--text-color);
      background-origin: content-box;
      text-decoration: none;
    }
    a:hover {
      background-size: 100% 100%;
      color: var(--brandblue-main);
    }
  }

  .party {
    position: absolute;
    bottom: 17%;
    @media only screen and (max-width: 600px) {
      bottom: 18%;
    }
    left: 4%;
    span {
      padding: 0.2rem 0.6rem;
      font-weight: 600;
      color: #fff;
    }
  }

  .mitte {
    .party span {
      background-color: rgb(214, 134, 43);
    }
    .photo img {
      border-color: rgb(214, 134, 43);
    }
  }
  .fdp {
    .party span {
      background-color: rgb(56, 114, 181);
    }
    .photo img {
      border-color: rgb(56, 114, 181);
    }
  }
  .svp {
    .party span {
      background-color: #4b8a3e;
    }
    .photo img {
      border-color: #4b8a3e;
    }
  }
  .sp {
    .party span {
      background-color: rgb(240, 85, 77);
    }
    .photo img {
      border-color: rgb(240, 85, 77);
    }
  }
  .grüne {
    .party span {
      background-color: #83b547;
    }
    .photo img {
      border-color: #83b547;
    }
  }
  .glp {
    .party span {
      background-color: #c4c43d;
    }
    .photo img {
      border-color: #c4c43d;
    }
  }
  .evp {
    .party span {
      background-color: #e6c820;
    }
    .photo img {
      border-color: #e6c820;
    }
  }
  .edu {
    .party span {
      background-color: #a65e42;
    }
    .photo img {
      border-color: #a65e42;
    }
  }

  .top {
    display: grid;
    position: relative;
  }

  .top.odd {
    grid-template-columns: 30% 70%;
    @media only screen and (max-width: 600px) {
      grid-template-columns: 40% 60%;
    }

    .right {
      padding-left: 2.2rem;
      @media only screen and (max-width: 600px) {
        padding-left: 1.4rem;
      }
      .info {
        width: 70%;
        @media only screen and (max-width: 600px) {
          width: 60%;
        }
      }
    }

    .party {
      right: 4%;
      left: unset;
    }
  }
  .top.even {
    grid-template-columns: 70% 30%;
    @media only screen and (max-width: 600px) {
      grid-template-columns: 60% 40%;
    }
    text-align: right;

    .left {
      padding-right: 2.2rem;
      @media only screen and (max-width: 600px) {
        padding-right: 1.4rem;
      }
      .info {
        width: 70%;
        @media only screen and (max-width: 600px) {
          width: 60%;
        }
        h4,
        .party {
          padding-right: 2.2rem;
          @media only screen and (max-width: 600px) {
            padding-right: 1rem;
          }
        }
      }
    }
  }
`

export default GridItem
